<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement"><p style="text-indent:0em;margin-top:100px;">A good book, Maggie. One of the greatest pleasures in life. Matt.</p>
<p style="text-indent:0em;margin-top:100px;">An empty lighthouse, its solid walls still dazzling white.</p><br/>
<p style="text-indent:0em;">Before it a deserted garden, its once tended furrows lined with rows of wild irises amid blown bladder wrack.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?2e9c8742